import { createTranslationKeysObject } from "utils/createTranslationKeysObject";

import { enGb } from "../translations";

export const TRANSLATION_KEYS = createTranslationKeysObject(enGb);
